import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SparkPatientOption {
  ID: number | undefined;
  FullName: string;
  searchString?: string;
}

@Component({
  selector: 'app-spark-header',
  templateUrl: './spark-header.component.html',
  styleUrls: ['../top-bar/top-bar.component.css', './spark-header.component.css'],
  standalone: false,
})
export class SparkHeaderComponent {
  @Input() title = '';
  @Input() compact = false;
  @Input() loggedInUsername = '';
  @Input() patients: SparkPatientOption[] = [];
  @Input() selectedPatientID: number | null | undefined;
  @Input() showPatientSelector = true;
  @Input() showSignOut = true;
  @Input() offlinePatientsActive = false;
  @Input() sendingLogs = false;
  @Input() signingOut = false;
  @Input() hasUpdateAvailable = false;
  @Input() academyMode = false;
  @Input() isdIopMode = false;
  @Input() parentMode = false;
  @Input() openMenu = false;
  @Output() openMenuChange = new EventEmitter<boolean>();
  @Output() patientChanged = new EventEmitter<number>();
  @Output() sendLogs = new EventEmitter<void>();
  @Output() offlinePatients = new EventEmitter<void>();
  @Output() signOut = new EventEmitter<void>();

  setOpenMenu(open: boolean): void { this.openMenu = open; this.openMenuChange.emit(open); }
}
